var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 27",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 4.125H16.625L14.4219 1.92187C13.8281 1.32812 13.0313 1 12.2031 1H4.125C2.40625 1 1.01562 2.40625 1.01562 4.125L1 22.875C1 24.5938 2.40625 26 4.125 26H29.125C30.8438 26 32.25 24.5938 32.25 22.875V7.25C32.25 5.53125 30.8438 4.125 29.125 4.125Z",
    fill: "none",
    stroke: "inherit",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0721 10.375C22.4273 10.375 23.536 11.4838 23.536 12.8389C23.536 14.1941 22.4273 15.3029 21.0721 15.3029C19.7169 15.3029 18.6082 14.1941 18.6082 12.8389C18.6082 11.4838 19.7169 10.375 21.0721 10.375Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 20.2308H16.1443V18.9989C16.1443 17.3603 19.4337 16.5349 21.0722 16.5349C22.7107 16.5349 26.0001 17.3603 26.0001 18.9989V20.2308Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.4b22193f.svg";
export { ForwardRef as ReactComponent };